exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-popup[data-v-7e8e0b0c] {\n  line-height: 22px;\n  color: #21364c;\n}\n.privacy-popup h2[data-v-7e8e0b0c] {\n  border-bottom: none;\n}\n.privacy-popup p[data-v-7e8e0b0c] {\n  margin-bottom: 18px;\n  line-height: 22px;\n  color: #21364c;\n}\n.privacy-popup a[data-v-7e8e0b0c] {\n  color: #00f;\n  text-decoration: underline;\n}", ""]);

// exports
